import { useRequest } from 'ahooks';
import {
  Card,
  Drawer,
  List,
  message,
  Space,
  Spin,
  Statistic,
  Tag,
} from 'antd';
import { examReportController } from '../../api';
import { useCompany } from '../../hooks/company';
import { formatDuration, optionLetter, QuestionTypeTag } from './constants';

interface Props {
  attemptId: I.ID;
  onClose: () => void;
}

// 答题详情（管理/主管视角）：逐题展示考生答案与正确答案的对照，错在哪一题一目了然。
// 后端校验权限：考试管理看全公司，部门成绩权限限本部门及子部门
export default ({ attemptId, onClose }: Props) => {
  const { id: companyId } = useCompany();

  const { data, loading } = useRequest(
    () => examReportController.attemptAdminResult(companyId, attemptId),
    {
      onError: (e) => {
        message.error(e.message);
        onClose();
      },
    },
  );

  return (
    <Drawer
      title={
        data
          ? `答题详情：${data.userName}（${data.examTitle} · 第 ${data.attemptNo} 次）`
          : '答题详情'
      }
      open
      width={860}
      onClose={onClose}
    >
      <Spin spinning={loading}>
        {data && (
          <>
            <Card style={{ textAlign: 'center' }}>
              <Space size={40}>
                <Statistic
                  title="得分"
                  value={data.score}
                  suffix={`/ ${data.totalScore}`}
                  valueStyle={{ color: data.pass ? '#3f8600' : '#cf1322' }}
                />
                <Statistic title="及格线" value={data.passScore} />
                <Statistic
                  title="用时"
                  value={formatDuration(data.durationSeconds)}
                />
                <Statistic title="部门" value={data.departmentName || '-'} />
              </Space>
              {data.isAutoSubmit && (
                <div style={{ marginTop: 8 }}>
                  <Tag color="orange">超时自动交卷</Tag>
                </div>
              )}
            </Card>
            <List
              style={{ marginTop: 16 }}
              dataSource={data.answers}
              renderItem={(item) => (
                <List.Item>
                  <div style={{ width: '100%' }}>
                    <Space>
                      <b>第 {item.seq} 题</b>
                      <QuestionTypeTag type={item.type} />
                      {item.isCorrect ? (
                        <Tag color="green">答对 +{item.gotScore} 分</Tag>
                      ) : (
                        <Tag color="red">答错 0 / {item.score} 分</Tag>
                      )}
                    </Space>
                    <p style={{ margin: '8px 0' }}>{item.content}</p>
                    <div style={{ color: '#888' }}>
                      {(item.options || []).map((option, index) => (
                        <div key={index}>
                          {optionLetter(index)}. {option}
                        </div>
                      ))}
                    </div>
                    <Space style={{ marginTop: 8 }}>
                      <span>
                        考生答案：
                        {item.myAnswer ? (
                          <Tag color={item.isCorrect ? 'green' : 'red'}>
                            {item.myAnswer}
                          </Tag>
                        ) : (
                          <Tag>未作答</Tag>
                        )}
                      </span>
                      <span>
                        正确答案：<Tag color="blue">{item.correctAnswer}</Tag>
                      </span>
                    </Space>
                  </div>
                </List.Item>
              )}
            />
          </>
        )}
      </Spin>
    </Drawer>
  );
};
